// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1201":"2a8d95921c2f42af","7900":"0d26cacf79c6500a"}[chunkId] + ".css";
};